var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { style: { width: _vm.width + "px", height: _vm.height + "px" } },
    [
      _vm.settings.type == "table"
        ? _c(
            "div",
            {
              staticClass: "scroll",
              style: {
                width: _vm.width + "px",
                height: _vm.height + "px",
                border: "1px solid " + _vm.settings.colors.frame,
                backgroundColor: _vm.settings.colors.background
              }
            },
            [
              _c("table", [
                _vm.settings.fonts.title > 0
                  ? _c("thead", [
                      _c(
                        "tr",
                        _vm._l(_vm.values.column_names, function(data) {
                          return _c("th", [
                            _c(
                              "p",
                              {
                                style: {
                                  fontSize:
                                    _vm.settings.fonts.title * _vm.fontScale +
                                    "px"
                                }
                              },
                              [_vm._v(_vm._s(data))]
                            )
                          ])
                        }),
                        0
                      )
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "tbody",
                  _vm._l(_vm.values.column_data, function(column) {
                    return _c(
                      "tr",
                      _vm._l(column, function(data) {
                        return _c("td", [
                          _c(
                            "p",
                            {
                              style: {
                                fontSize:
                                  _vm.settings.fonts.value * _vm.fontScale +
                                  "px"
                              }
                            },
                            [_vm._v(_vm._s(data))]
                          )
                        ])
                      }),
                      0
                    )
                  }),
                  0
                )
              ])
            ]
          )
        : _vm.settings.type == "image"
        ? _c(
            "div",
            {
              style: {
                width: _vm.width + "px",
                height: _vm.height + "px",
                border: "1px solid " + _vm.settings.colors.frame,
                backgroundColor: _vm.settings.colors.background
              }
            },
            [
              _c("canvas", {
                attrs: { id: _vm.id, width: _vm.width, height: _vm.height }
              })
            ]
          )
        : _vm.settings.type == "download"
        ? _c(
            "div",
            {
              style: {
                width: _vm.width + "px",
                height: _vm.height + "px",
                border: "1px solid " + _vm.settings.colors.frame,
                backgroundColor: _vm.settings.colors.background
              }
            },
            [
              _c(
                "p",
                {
                  style: {
                    fontSize: _vm.settings.fonts.title * _vm.fontScale + "px"
                  }
                },
                [_c("b", [_vm._v(_vm._s(_vm.settings.title))])]
              ),
              _vm._v(" "),
              _c(
                "button",
                {
                  on: {
                    click: function($event) {
                      return _vm.download()
                    }
                  }
                },
                [_c("font-awesome-icon", { attrs: { icon: "download" } })],
                1
              )
            ]
          )
        : _c(
            "div",
            {
              style: {
                width: _vm.width + "px",
                height: _vm.height + "px",
                border: "1px solid " + _vm.settings.colors.frame,
                backgroundColor: _vm.settings.colors.background
              }
            },
            [
              _c(
                "button",
                {
                  on: {
                    click: function($event) {
                      return _vm.toggleLegend()
                    }
                  }
                },
                [_c("font-awesome-icon", { attrs: { icon: "star" } })],
                1
              ),
              _vm._v(" "),
              _c("canvas", {
                attrs: { id: _vm.id, width: _vm.width, height: _vm.height }
              }),
              _vm._v(" "),
              _c("canvas", {
                staticClass: "legend",
                attrs: {
                  id: _vm.id + "_legend",
                  width: "200px",
                  height: "200px"
                }
              })
            ]
          )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-100b0462", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-100b0462","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/layouts/chart.vue
// module id = 857
// module chunks = 0